import { render, staticRenderFns } from "./ManualImport.vue?vue&type=template&id=2accbc30&scoped=true"
import script from "./ManualImport.vue?vue&type=script&lang=js"
export * from "./ManualImport.vue?vue&type=script&lang=js"
import style0 from "./ManualImport.vue?vue&type=style&index=0&id=2accbc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2accbc30",
  null
  
)

export default component.exports